import { IconMail, IconMailOpened, IconPhone } from "@tabler/icons-react";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import { IconLocation } from "@tabler/icons-react";
import { useState } from "react";
import axios from "axios";
import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";


function Register() {

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);

  const handleRegsiter = async (e) => {
    e.preventDefault()

    // Basic form validation
    if (!username || !email || !password || !confirmPassword) {
      toast.error("Please fill in all fields");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post("https://gearup-car-hire.onrender.com/api/user/register", {
        username,
        email,
        password
      });
      if (response.data) {
        toast.success("Registration successful!");
        // navigate('/signin')
      }
      console.log(response.data);

    } catch (err) {
      if (err.response) {
        if (err.response.status === 409) {
          toast.error("User already exists. Please use a different email.");
        } else {
          toast.error(err.response.data.message || "An error occurred during registration");
        }
      } else {
        toast.error("An error occurred during registration");
      }
    } finally {
      setIsLoading(false);
    }
  }
  return (
    <>
      <section className="contact-page">
        <HeroPages name="Register" />
        <div className="container">
          <div className="contact-div">
            <div className="contact-div__text">
              <h2>Register Your Account</h2>
              <p>
                A multifaceted professional skilled in multiple fields of
                research, development as well as a learning specialist. Over 15
                years of experience.
              </p>
              <a href="/">
                <IconPhone /> &nbsp; (123) 456-7869
              </a>
              <a href="/">
                <IconMail /> &nbsp; carrental@carmail.com
              </a>
              <a href="/">
                <IconLocation />
                &nbsp; Belgrade, Serbia
              </a>
            </div>
            <div className="contact-div__form">
              <form onSubmit={handleRegsiter}>
                <label htmlFor="username">
                  Full Name <b>*</b>
                </label>
                <input required type="text" placeholder='E.g: "Joe Shmoe"' name="username" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete></input>

                <label htmlFor="email">
                  Email <b>*</b>
                </label>
                <input required type="email" placeholder="youremail@example.com" name="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete></input>

                <label htmlFor="password">
                  Password <b>*</b>
                </label>
                <input required type="password" placeholder="Enter your Password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete></input>

                <label htmlFor="confirmPassword">
                  Confirm Password <b>*</b>
                </label>
                <input required type="password" placeholder="Confirm your Password" name="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} autoComplete></input>



                <button type="submit" disabled={isLoading}>
                  <IconMailOpened />
                  &nbsp; {isLoading ? "Registering..." : "Register"}
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content">
              <h2>Book a car by getting in touch with us</h2>
              <span>
                <IconPhone width={40} height={40} />
                <h3>(123) 456-7869</h3>
              </span>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Register;
